'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _VstMenu = require('./VstMenu');

var _VstMenu2 = _interopRequireDefault(_VstMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstLittleHead = function (_VstComponent) {
  _inherits(VstLittleHead, _VstComponent);

  function VstLittleHead() {
    _classCallCheck(this, VstLittleHead);

    var _this = _possibleConstructorReturn(this, (VstLittleHead.__proto__ || Object.getPrototypeOf(VstLittleHead)).call(this));

    _this._clickLilHead = _this._clickLilHead.bind(_this);
    _this._closeMenu = _this._closeMenu.bind(_this);
    _this.state = {
      menuRight: 0,
      visible: false
    };
    return _this;
  }

  _createClass(VstLittleHead, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // update the location of the dropdown menu depending on the location of the button
      var menuRight = window.innerWidth - this.refs.lilHeadButton.offsetLeft - this.refs.lilHeadButton.offsetWidth;
      if (menuRight !== this.state.menuRight) {
        // TODO: fix lint error
        /* eslint-disable react/no-did-update-set-state */
        this.setState({ menuRight: menuRight });
        /* eslint-enable react/no-did-update-set-state */
      }
    }
  }, {
    key: '_clickLilHead',
    value: function _clickLilHead() {
      this.setState({ visible: !this.state.visible });
    }
  }, {
    key: '_closeMenu',
    value: function _closeMenu() {
      this.setState({ visible: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        { ref: 'lilHeadButton', id: 'lil-head-button', className: (0, _classnames2.default)('lil-head-item', { expanded: this.state.visible }) },
        _react2.default.createElement(
          'button',
          { className: 'vst-no-button',
            onClick: this._clickLilHead,
            'aria-expanded': this.state.visible
          },
          _react2.default.createElement(
            'span',
            { className: 'vst-off-screen' },
            i18n.t('global-bar.account')
          )
        ),
        _react2.default.createElement(
          _VstMenu2.default,
          { className: 'lil-head-menu',
            visible: this.state.visible,
            closeMenu: this._closeMenu
          },
          this.props.children
        )
      );
    }
  }]);

  return VstLittleHead;
}(_VstComponent3.default);

exports.default = VstLittleHead;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstLilHead.js
 **/